import script from "./AdminRoster.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminRoster.vue?vue&type=script&setup=true&lang=js"

import "./AdminRoster.vue?vue&type=style&index=0&id=51ca1c22&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51ca1c22"]])

export default __exports__